const TITLE_CONFIG = {
    default: {
        cn: '工作空间 - 智慧芽',
        en: 'Workspace - Patsnap',
        tw: '工作空間 - 智慧芽',
        jp: 'ワークスペース - Patsnap',
    },
    taskDetail: {
        cn: '查阅详情 - 智慧芽',
        en: 'Review Details - Patsnap',
        tw: '查閱詳情 - 智慧芽',
        jp: '詳細のレビュー - Patsnap',
    },
};
let lastLocale = 'en';
export function replaceWhiteLabelTitle({ title = '', isWhiteLabel = false }) {
    if (!isWhiteLabel)
        return title;
    return title.replace(/( - Patsnap)$|( - 智慧芽)$/i, '');
}
export default function setTitle({ locale = lastLocale, type = 'default', isWhiteLabel = false }) {
    const titleObj = TITLE_CONFIG[type];
    lastLocale = locale;
    document.title = replaceWhiteLabelTitle({ title: titleObj[locale], isWhiteLabel });
}
export function setTitlePrefix({ prefix, type = 'default', isWhiteLabel = false }) {
    const titleObj = TITLE_CONFIG[type];
    const preStr = prefix ? `${prefix} - ` : '';
    document.title = replaceWhiteLabelTitle({ title: `${preStr}${titleObj[lastLocale]}`, isWhiteLabel });
}
